module.exports = __webpack_public_path__ + "img/blshj02_center_001.8858c875.png";